function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["event"],
  _excluded2 = ["event"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import mixpanel from 'mixpanel-browser';
import { isIdentityAvailable, getUserId, getUserType, getTempId } from "../utils/identity";
import Queue from "../Queue";
// Initilize MixPanel
mixpanel.init(window.MIXPANEL_PROJECT_TOKEN || 'f4dec87d2f8024c1d41844c6b1594b01', {
  // debug mode, enabled only on local development machine
  debug: !window.MIXPANEL_PROJECT_TOKEN

  // TODO: Investigate to use use localStorage instead of cookies (this will be a separte ticket / PR, UIE-858)
  // https://developer.mixpanel.com/docs/javascript-full-api-reference#mixpanelset_config
});
// Create a localstorage buffer for the MixPanel events
var queue = new Queue('ab_events-buffer-for-mixpanel');

/**
 * The identify call can used to attach user properties the current user.
 * Destinations will then use that data to create a single profile for that user,
 * even if data for that user comes from multiple places.
 * @param unique_id
 * @param properties
 */
export var identify = function identify(unique_id, properties) {
  //@ts-expect-error ToDo: fix this
  mixpanel.identify(unique_id, properties);
};

/**
 * The alias call can be used to specify one user id as an alias for another user id.
 * This is needed to implement the identify for some destinations, specifically Mixpanel.
 * @param new_id
 * @param old_id
 */
export var alias = function alias(new_id, old_id) {
  mixpanel.alias(new_id, old_id);
};

/**
 * Identifies user by creating a single profile and also associate multiple IDs
 * into the single profile, if provided (e.g. User ID and Temporary ID).
 *
 * This method is when User ID becomes available or it is not required.
 *
 * NOTE: Temporary ID is created for the new unauthenticated users.
 * @param identity
 */
var identifyUser = function identifyUser(identity) {
  var _window$user_context, _identity$userInfo, _window$user_context2, _window$user_context3;
  var tempId = getTempId(); // temporary ID for anonymous users (stored in localstorage)

  // NOTE: The SPA's "index.html.ejs" page makes a call to an /api/v2/me API endpoint which
  //       returns a 'user_context' and it assigns it to the window object.
  var userId = (identity === null || identity === void 0 ? void 0 : identity.id) || ((_window$user_context = window.user_context) === null || _window$user_context === void 0 ? void 0 : _window$user_context.id);
  var userType = (identity === null || identity === void 0 ? void 0 : (_identity$userInfo = identity.userInfo) === null || _identity$userInfo === void 0 ? void 0 : _identity$userInfo.role) || ((_window$user_context2 = window.user_context) === null || _window$user_context2 === void 0 ? void 0 : _window$user_context2.role);

  // First, try to identify user with its primary User ID, if exists (or it's an anonymous user)
  if (userId) {
    // Authenticated user
    identify(userId, {
      userType: userType // used for backward compatibility (adding old 'userType' attribute beside new 'user_id' attribute )
    });
  } else {
    // Anonymous user that does not have a User ID (e.g. PWS SPA), so we're using a Temporary ID to identify user
    identify(tempId, {
      userType: 'unknown'
    });
  }

  // Second, associate another ID with the primary User ID
  if (identity !== null && identity !== void 0 && identity.id) {
    // A new registered user gets a new User ID which we associate with the previous created Temporary ID
    alias(tempId, identity.id);
  } else if ((_window$user_context3 = window.user_context) !== null && _window$user_context3 !== void 0 && _window$user_context3.id) {
    // User is autheticated and we're associating a Temporary ID with a User ID
    alias(window.user_context.id, tempId);
  }
};

/**
 * Once the current user is identified, this method dispatches events from the localstorage.
 */
var sendEventsFromLocalstorage = function sendEventsFromLocalstorage() {
  if (queue.size() > 0) {
    // Dispatch one event at a time (from localstorage)
    for (var index = 0; index < queue.size(); index++) {
      var _data$flush;
      var _queue$dequeue = queue.dequeue(),
        eventName = _queue$dequeue.event,
        data = _objectWithoutProperties(_queue$dequeue, _excluded);
      // Events in the localstorage were missing the User ID and Role,
      // now that they're available we will assign the values
      var eventData = _objectSpread(_objectSpread({}, data), {}, {
        event: eventName,
        user_id: getUserId(),
        user_type: getUserType()
      });
      mixpanel.track(eventName, eventData, {
        send_immediately: (_data$flush = data.flush) !== null && _data$flush !== void 0 ? _data$flush : false
      });
    }
  }
};

/**
 * Dispatches events to the MixPanel or temporary stored them in the localstorage until user is
 * identified. Once the user is identified it will first dispatch events from the localstorage
 * before dispatching the latest event.
 *
 * Events have timestamp at the moment they were created so the timeline will be respected
 * regardless of events being immediatelly dispatched to the MixPanel or temporary stored
 * in the localstorage.
 * @param event
 */
export var sendEventToMixpanel = function sendEventToMixpanel(event) {
  try {
    // Make sure that an error dispatching event does not bring the application down
    if (isIdentityAvailable()) {
      // First, identify current user
      identifyUser();
      // Second, check if there are any events in the localstorage and send them first
      sendEventsFromLocalstorage();
      // Finally, send the latest created event
      if (event) {
        var _event$flush;
        var eventName = event.event,
          eventData = _objectWithoutProperties(event, _excluded2);
        mixpanel.track(eventName, eventData, {
          send_immediately: (_event$flush = event.flush) !== null && _event$flush !== void 0 ? _event$flush : false
        });
      }
    } else {
      // Temporary store event in the localstorage (until the identity of the user is set)
      if (event) {
        queue.enqueue(event);
      }
    }
  } catch (e) {
    // Something went wrong while dispatching or storing event, create a warning with error
    console.warn('MixPanel Plugin: Failed to dispatch event', e);
  }
};